import { State, initialState, Actions, GET_COMPONENT_FILE, GET_COMPONENT_FILE_ERROR, GET_COMPONENT_FILE_SUCCESS } from "../../types/file/get-component-file.dto";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_COMPONENT_FILE:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_COMPONENT_FILE_SUCCESS:
      return {
        ...state,
        data: JSON.parse(JSON.stringify(action.payload)),
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_COMPONENT_FILE_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    default:
      return { ...state };
  }
};

export default reducers;
